import React from "react"
import { styled, StyleProps } from ".."

const ClearIconSVG = ({ ...props }: React.SVGAttributes<SVGElement> & StyleProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 0 16 16" width="16px" {...props}>
    <path d="M0 0h16v16H0V0z" fill="none" />
    <path
      fill={props.fill}
      d="M 12.667969 4.273438 L 11.726562 3.332031 L 8 7.058594 L 4.273438 3.332031 L 3.332031 4.273438 L 7.058594 8 L 3.332031 11.726562 L 4.273438 12.667969 L 8 8.941406 L 11.726562 12.667969 L 12.667969 11.726562 L 8.941406 8 Z M 12.667969 4.273438 "
    />
  </svg>
)

export const ClearIcon = styled(ClearIconSVG)((props: StyleProps) => ({
  fill: props.theme.palette.grey.dark,
  flexShrink: 0,
  marginTop: `2px`,
}))
